<script>
import createTargetingInfoSelect from '@/components/account/targetingInfo/createTargetingInfoSelect';
import { SECTION_CODES } from '@/constants';

export default createTargetingInfoSelect({
  parentCode: SECTION_CODES.GENDER,
});
</script>

<style lang="scss">
@import '~@/assets/styles/colors';

.gc-00010048-picker .section-group.ant-radio-group {
  .ant-radio-button-wrapper {
    padding-left: 36px;
  }

  .ant-radio-button-wrapper-checked {
    .ant-radio-button:before {
      background-color: $primary;
    }
  }

  .ant-radio-button:before {
    content: ' ';
    height: 24px;
    width: 24px;
    margin-left: -30px;
    position: absolute;
    top: 2px;
    background-color: $text-grey;
  }

  .gc-000100480049 .ant-radio-button:before {
    mask: url('~@/assets/icons/female.svg') no-repeat center;
  }

  .gc-000100480050 .ant-radio-button:before {
    mask: url('~@/assets/icons/male.svg') no-repeat center;
  }

  .gc-000100480051 .ant-radio-button:before {
    mask: url('~@/assets/icons/other.svg') no-repeat center;
  }
}
</style>
